module.exports = __webpack_public_path__ + "img/reward.b64e0e3f.svg";